<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-row class="fill-height" no-gutters>
          <v-col class="col-12">
            <v-row>
              <v-col class="col-12">
                <v-card-title>
                  <v-row>
                    <v-col class="col-6 col-md-4">
                      <h1 class="primary-color">Contexts</h1>
                    </v-col>
                    <v-spacer />
                    <v-col class="col-6 col-md-2">
                      <v-btn class="new-item-btn float-right" block @click="openCreateContext">
                        <v-icon size="20">mdi-plus</v-icon>
                        &nbsp;&nbsp;Create context
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-alert
                  v-if="messageCreateContext"
                  outlined
                  :color="successfullCreateContext ? 'success' : 'error'"
                  :icon="successfullCreateContext ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageCreateContext }}
                </v-alert>
                <v-alert
                  v-if="messageDeleteContext"
                  outlined
                  :color="successfullDeleteContext ? 'success' : 'error'"
                  :icon="successfullDeleteContext ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageDeleteContext }}
                </v-alert>
                <v-alert
                  v-if="messageEditContext"
                  outlined
                  :color="successfullEditContext ? 'success' : 'error'"
                  :icon="successfullEditContext ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageEditContext }}
                </v-alert>
                <v-data-table
                  :headers="headers"
                  :items="contexts"
                  item-key="id"
                  :loading="loading"
                  loading-text="Loading... Please, wait"
                  :server-items-length="pagination.totalItems"
                  :items-per-page="pagination.itemsPerPage"
                  :page.sync="pagination.page"
                  item-class="text-wrap"
                  @update:page="handlePageChange"
                >
                  <template #[`item.content`]="{ item }">
                    {{ item.content | slice100Characters }}
                  </template>
                  <template #[`item.createdAt`]="{ item }">
                    {{ item.createdAt | formatDate }}
                  </template>
                  <template #[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openShowDetails(item)">
                          <v-icon size="20" color="primary">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Show details</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openEditContext(item)">
                          <v-icon size="20" color="primary">mdi-square-edit-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit context</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openDeleteContext(item)">
                          <v-icon size="20" color="error">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete context</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-alert
              v-if="messageContexts"
              class="mt-4"
              outlined
              :color="successfullContexts ? 'success' : 'error'"
              :icon="successfullContexts ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageContexts }}
            </v-alert>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-dialog v-model="createContextDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="createContextForm" @submit.prevent="createContext">
          <v-card-title class="px-6">
            <h5 class="primary-color">Create Context</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="context.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="context.content"
                    class="py-0 mb-6 no-border-radius"
                    label="Content *"
                    :rules="rules"
                    dense
                  />
                </v-col>
              </v-row>
              <v-alert
                v-if="messageCreateContextInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullCreateContextInside ? 'success' : 'error'"
                :icon="successfullCreateContextInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageCreateContextInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelCreateContext"> Cancel </v-btn>
            <v-btn v-if="!creatingContext" type="submit" class="ok-modal"> Create </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editContextDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="editContextForm" @submit.prevent="editContext">
          <v-card-title class="px-6">
            <h5 class="primary-color">Update Context</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="itemToEdit.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="itemToEdit.content"
                    class="py-0 mb-6 no-border-radius"
                    label="Content *"
                    :rules="rules"
                    dense
                  />
                </v-col>
              </v-row>

              <v-alert
                v-if="messageEditContextInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullEditContextInside ? 'success' : 'error'"
                :icon="successfullEditContextInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageEditContextInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="editContextDialog = false"> Cancel </v-btn>
            <v-btn v-if="!editingContext" type="submit" class="ok-modal"> Update </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteContextDialog" max-width="500">
      <v-card>
        <v-card-title class="px-6">
          <h5 class="primary-color">Delete Context</h5>
        </v-card-title>
        <v-card-text class="mt-4 pb-0 px-6">
          <p class="mb-0">
            Do you really want to delete the selected context? <br />
            If so, press Confirm.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text class="cancel-modal" @click="deleteContextDialog = false"> Cancel </v-btn>

          <template v-if="!deletingContext">
            <v-btn class="ok-modal" @click="deleteContext"> Confirm </v-btn>
          </template>
          <v-btn v-else class="ok-modal" disabled @click="deleteContext">
            <v-progress-circular indeterminate color="primary" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDetailsContextDialog" max-width="1000">
      <v-card>
        <v-form ref="detailsContextForm">
          <v-card-title class="px-6">
            <h5 class="primary-color">Details</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Name:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.name }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Legacy name:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.content }}</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="showDetailsContextDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ContextsDataService from '@/services/ContextsDataService';

export default {
  name: 'ContextsList',
  data() {
    return {
      contexts: [],
      successfullContexts: false,
      messageContexts: '',
      loading: false,
      successfullCreateContext: false,
      messageCreateContext: '',
      successfullCreateContextInside: false,
      messageCreateContextInside: '',
      successfullEditContext: false,
      messageEditContext: '',
      successfullEditContextInside: false,
      messageEditContextInside: '',
      successfullDeleteContext: false,
      messageDeleteContext: '',
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Content', value: 'content', sortable: false },
        {
          text: 'Created at',
          value: 'createdAt',
          sortable: false,
          width: '200px',
        },
        { text: 'Actions', value: 'actions', sortable: false, width: '200px' },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalPages: 1,
        totalItems: 0,
      },
      context: {
        name: '',
        content: '',
      },
      rules: [(v) => !!v || 'Required field'],
      createContextDialog: false,
      creatingContext: false,
      editContextDialog: false,
      editingContext: false,
      deleteContextDialog: false,
      deletingContext: false,
      itemToEdit: {},
      itemToDelete: {},
      itemToShow: {},
      showDetailsContextDialog: false,
    };
  },
  async mounted() {
    await this.getAllContexts(1);
  },
  methods: {
    getAllContexts(page) {
      this.loading = true;

      ContextsDataService.findAll(page, this.pagination.itemsPerPage).then(
        (response) => {
          if (response.status == 200) {
            this.contexts = response.data.data;

            if (this.contexts.length !== 0) {
              this.pagination.page = page;
              this.pagination.totalPages = response.data.links.totalPages || 1;

              this.pagination.totalItems =
                response.data.links.totalItems ||
                this.pagination.totalPages * this.pagination.itemsPerPage;
            }
          } else {
            this.successfullContexts = false;
            this.messageContexts =
              'An error has occurred retrieving the list of contexts. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullContexts = false;
          this.messageContexts =
            'An error has occurred retrieving the list of contexts. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.getAllContexts(newPage);
    },
    openCreateContext() {
      this.createContextDialog = true;
    },
    createContext() {
      this.successfullCreateContext = true;
      this.messageCreateContext = '';

      if (this.$refs.createContextForm.validate()) {
        this.creatingContext = true;

        ContextsDataService.create(this.context).then(
          (response) => {
            if (response.status == 201) {
              this.getAllContexts(1);

              this.messageCreateContext = '';
              this.successfullCreateContext = true;

              setTimeout(() => {
                this.messageCreateContext = 'Context successfully created.';
              }, 10);
            } else {
              this.messageCreateContext = '';
              this.successfullCreateContext = false;

              setTimeout(() => {
                this.messageCreateContext =
                  'An error has occurred creating the context. Please, try again later.';
              }, 10);
            }
            this.createContextDialog = false;
            this.creatingContext = false;
            this.context = {
              name: '',
              content: '',
            };
          },
          (error) => {
            this.messageCreateContextInside = '';
            this.messageCreateContext = '';

            if (error.response.status === 409) {
              this.successfullCreateContextInside = false;

              setTimeout(() => {
                this.messageCreateContextInside =
                  'Context already in use. Please, change its name.';
              }, 10);
            } else if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            } else {
              this.successfullCreateContext = false;

              setTimeout(() => {
                this.messageCreateContext =
                  'An error has occurred creating the context. Please, try again later.';
              }, 10);

              this.createContextDialog = false;
              this.context = {
                name: '',
                content: '',
              };
            }

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            this.creatingContext = false;
          }
        );
      }
    },
    cancelCreateContext() {
      this.createContextDialog = false;
      this.context = {
        name: '',
        content: '',
      };
    },
    openEditContext(context) {
      this.itemToEdit = { ...context };
      this.editContextDialog = true;
    },
    editContext() {
      this.successfullEditContext = true;

      if (this.$refs.editContextForm.validate()) {
        this.editingContext = true;

        ContextsDataService.update(this.itemToEdit).then(
          (response) => {
            if (response.status == 204) {
              this.getAllContexts(1);
              this.messageEditContext = '';
              this.successfullEditContext = true;

              setTimeout(() => {
                this.messageEditContext = 'Context successfully updated.';
              }, 10);
            } else {
              this.messageEditContext = '';
              this.successfullEditContext = true;

              setTimeout(() => {
                this.messageEditContext =
                  'An error has occurred updating the context. Please, try again later.';
              }, 10);
            }

            this.editContextDialog = false;
            this.editingContext = false;
            this.itemToEdit = {};
          },
          (error) => {
            this.messageEditContextInside = '';
            this.messageEditContext = '';

            if (error.response.status === 409) {
              this.successfullEditContextInside = false;

              setTimeout(() => {
                this.messageEditContextInside = 'Context already in use. Please, change its name.';
              }, 10);
            } else if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            } else {
              this.successfullEditContext = false;

              setTimeout(() => {
                this.messageEditContext =
                  'An error has occurred updating the context. Please, try again later.';
              }, 10);

              this.editContextDialog = false;
              this.itemToEdit = {};
            }

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            this.editingContext = false;
          }
        );
      }
    },
    openDeleteContext(context) {
      this.itemToDelete = { ...context };
      this.deleteContextDialog = true;
    },
    deleteContext() {
      if (this.itemToDelete.id !== undefined) {
        this.deletingContext = true;

        ContextsDataService.delete(this.itemToDelete.id).then(
          (response) => {
            if (response.status == 204) {
              this.getAllContexts(1);
              this.messageDeleteContext = '';
              this.successfullDeleteContext = true;

              setTimeout(() => {
                this.messageDeleteContext = 'Context successfully deleted.';
              }, 10);
            } else {
              this.messageDeleteContext = '';
              this.successfullDeleteContext = false;

              setTimeout(() => {
                this.messageDeleteContext =
                  'An error has occurred deleting the context. Please, try again later.';
              }, 10);
            }

            this.deleteContextDialog = false;
            this.deletingContext = false;
            this.itemToDelete = {};
          },
          (error) => {
            this.messageDeleteContext = '';
            this.successfullDeleteContext = false;

            setTimeout(() => {
              this.messageDeleteContext =
                'An error has occurred deleting the context. Please, try again later.';
            }, 10);

            this.deleteContextDialog = false;
            this.itemToDelete = {};

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            }

            this.deletingContext = false;
          }
        );
      } else {
        this.messageDeleteContext = '';
        this.successfullDeleteContext = false;

        setTimeout(() => {
          this.messageDeleteContext =
            'An error has occurred deleting the context. Please, try again later.';
        }, 10);

        this.deleteContextDialog = false;
        this.itemToDelete = {};
      }
    },
    openShowDetails(context) {
      this.itemToShow = { ...context };
      this.showDetailsContextDialog = true;
    },
  },
};
</script>
